export default __webpack_public_path__ + "static/media/juice-fruit-l-mobile@3x.de28317a.png";